import React from 'react';

import { IBasicStyledProps, SkeletonElement } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledPriceColumn, StyledOptionTitleSkeleton, StyledDropdownItemSkeleton, StyledRadioButton } from './styled';

export const PaymentItemSkeleton: ReactFCV<IBasicStyledProps> = (rest) => (
  <StyledDropdownItemSkeleton {...rest}>
    <StyledRadioButton checked={true} name={'name'} disabled={false}>
      <StyledOptionTitleSkeleton data-testid="skeleton-title" height={2} />
    </StyledRadioButton>
    <StyledPriceColumn data-testid="skeleton-price">
      <SkeletonElement data-testid="skeleton-element" width={1} height={2} />
    </StyledPriceColumn>
  </StyledDropdownItemSkeleton>
);
